module.exports = __webpack_public_path__ + "static/media/eSports-banner.31efa332.png";